<div class="app-page">
  <h2>
    <mat-icon>grid_view</mat-icon>
    PROFILE VIEWS &nbsp;
  </h2>
  <mat-divider></mat-divider>
  <br/>
  <a mat-button [routerLink]="['/testview/', 'NEW']" color="primary">
    <mat-icon>add</mat-icon>
    NEW
  </a>
  <div class="app-page" style="display: flex; flex-wrap: wrap;">

    @if (this.TestViews) {
      @for (view of this.TestViews; track view) {
        <app-config-test-view-card [TestView]="view" (onDelete)="refresh()">
        </app-config-test-view-card>
      }
    }


  </div>
</div>